
<f-dialog
    v-if="show"
    v-model       = "show"
    :width        = "450"
    :show-header  = "false"
    :hide-actions = "false"
    :inset        = "false"
    content-class = "dialog-border"
    :store-label  = "$t('dms.move.label')"
    :show-save    = "enableMove"
    @store        = "onMove"
    @cancel       = "onCancel"
>
    <template v-slot:content>
        <div class="pa-4">
            <div style="font-size: 16px; font-weight: 700" class="primary--text mb-1 pl-1">
                Dokument ...
            </div>
            <div class="lm-border pa-0" >
                <p-dms-entry-card
                    :document = "document"
                />
            </div>
            <div class="move-to-label primary--text">
                {{ $t('dms.move.to') }}
            </div>
            <div class="lm-border pa-2">
                <div class="v-flex">
                    <v-text-field
                        label   = "Ereignis"
                        v-model = "target.incident.id"
                        style   = "width: 90px"
                        type           = "Number"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                        @input  = "onIncident"
                    />
                    <div class="pl-2" style="padding-top: 18px; width: calc(100% - 90px)">
                        <f-read-only-field
                            :value="target.incident.type"
                            filled
                        />
                    </div>
                </div>

                <v-select
                    class="mb-2"
                    label          = "Bearbeitungsschritt"
                    v-model        = "target.step"
                    :items         = "targets"
                    item-value     = "id"
                    item-text      = "name"
                    :return-object = true
                    :disabled      = "!enableMove"
                />
            </div>
        </div>
    </template>
</f-dialog>
